type TranslationLangInfo = {
  name?: string;
  nativeName?: string;
  dir?: "ltr" | "rtl";
};

let translations: Record<string, TranslationLangInfo> = {};
let loaded = false;
let languages: Promise<void> | null = null;

export async function loadTranslationLanguages(): Promise<void> {
  if (loaded) {
    return;
  }
  if (languages) {
    return languages;
  }

  // Fetch the translation languages from the Microsoft Translator API and store them in the translations variable.
  // This will allow us to have access to the language names and native names for display purposes.
  const endpoint = "https://api.cognitive.microsofttranslator.com/languages?api-version=3.0&scope=translation";

  languages = fetch(endpoint)
    .then(response => response.json())
    .then(data => {
      translations = data.translation ?? {};
      loaded = true;
    });

  return languages;
}

export function getRawTranslationLanguages() {
  return translations;
}
